export const DEBUG_STORAGE_KEY = 'jw-debug';

/** Sentry Init State Machine */
export const INIT_STEPS = {
	COLD: 0,
	INITIALIZING: 1,
	INITIALIZED: 2,
	FAILED: 3,
} as const;

/** Firefox-specific errors that are almost always from third-party scripts */
export const SENTRY_IGNORED_ERRORS = [
	'NS_ERROR_NOT_INITIALIZED',
	'NS_ERROR_FAILURE',
	'NS_ERROR_NOT_AVAILABLE',
	'NS_ERROR_UNEXPECTED',
	'NS_ERROR_ABORT',
];

/**
 * User properties to check for SSR hydration mismatches
 * Source: persist-state.plugin.ts persistUserProperties list
 */
export const SSR_MISMATCH_PROPERTIES = [
	'accessToken',
	'hideSeenDislikedTitles',
	'isPremium',
	'userRole',
	'jwId',
	'jwLoginId',
	'lastUsedLoginProvider',
	'location',
	'loggedInProviders',
	'onboardingStatus',
	'persistedOverriddenLanguage',
	'persistedWebLocale',
	'newBuyboxTooltipAcknowledged',
	'loggedInNewBuyBoxView',
	'accountCreationTime',
	'showOldTitlePage',
] as const;

// Third-party domains whose network breadcrumbs add noise without diagnostic value
export const IGNORED_DOMAINS = [
	'analytics.google.com',
	'adtrafficquality.google',
	'doubleclick.net',
	'yieldlove',
	'translate.goog',
];
